import $ from 'jquery'
import _ from 'lodash'
import Backbone from 'backbone'
import moment from 'moment'
import appDisplay from 'scoreboard/components/app-display'
import calendars from 'scoreboard/components/calendars'
import CovertButtonTooltips from 'scoreboard/components/covert-button-tooltips'
import scrollContainer from 'scoreboard/components/scroll-container'
import DeleteConfirmation from 'scoreboard/components/delete-confirmation'
import EmptyState from 'scoreboard/components/empty-state'
import i18n from 'scoreboard/components/i18n'
import InfiniteScroller from 'scoreboard/components/infinite-scroller'
import LoadingDots from 'scoreboard/components/loading-dots'
import DisplayHeader from 'scoreboard/components/display-header'
import metadata from 'scoreboard/components/metadata'
import selects from 'scoreboard/components/selects'
import globals from 'scoreboard/components/globals'
import renderProjectDropdown from 'scoreboard/projects/render-project-dropdown'
import projects from 'scoreboard/projects/projects'
import config from 'scoreboard/components/config'
import template from './admin-shared-dashboards.hbs'
import rowTemplate from './admin-shared-dashboard-row.hbs'
import emptyTemplate from './no-shared-dashboards.hbs'
import SharedDashboardDialog from './admin-shared-dashboard-links'

const ALL_OPTION = -1

var SharedDashboards = Backbone.View.extend({

	className: 'admin shared-dashboards table-hack scroll-layout-xy display-layout form',

	events: {
		'click .action-send': 'onDisplayLinks',
		'click .action-delete': 'onDelete',
		'change .project-list': 'onProject',
		'change .org-list': 'onOrg'
	},

	//Backbone Functions

	initialize: function (options={}) {
		this.options = options
		this.dashboards = []
		this.projectId = projects.id
		this.orgId = ALL_OPTION
		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })
		this.section = this.options.section

		this.ALL_ORGS_OPTION = {
			label: i18n.get('report.common.optionList.organizations.all'),
			value: ALL_OPTION
		},

		this.ALL_PROJECTS = {
			id: ALL_OPTION,
			label: i18n.get('common.project.allProjects')
		}
	},

	render: function () {
		this.$el.empty().append(new DisplayHeader({
			heading: this.heading(),
			mobileGearHidden: true
		}).render().el, template({
			isForms: this.section === 'forms',
			projectsEnabled: projects.isVisible(),
			strategyMapsEnabled: config.displayStrategyMaps,
			heading: this.heading()
		}))

		this.covertButtonTooltips = new CovertButtonTooltips({el: this.el})
		this.table = this.$('.shared-dashboard-table')
		this.tableBody = this.$('.shared-dashboard-table tbody')
		this.projectSelector = this.$('.project-selector')
		this.projectSelector.hide()
		this.orgSelector = this.$('.org-selector')
		this.orgSelector.hide()

		// hide the table until there's data to display
		this.tableBody.empty()
		this.table.hide()

		this.loadingDots = new LoadingDots({ el: this.$('.loading-dots-container') })
		this.loadingDots.render()
		this.loadingDots.observeStream(this.stream)

		this._setupScrolling()
		this._listenForData()
		return this
	},

	heading: function () {
		let key
		if (this.section === 'forms') {
			key = 'admin.sharedForms'
		} else {
			// #30037 use "dashboards and strategy maps" if strategy maps are enabled
			key = config.displayStrategyMaps ?
			  'admin.sharedDashboards.strategyMaps' : 'admin.sharedDashboards'
		}
		return i18n.get(key)
	},

	//Event Handling

	_setupScrolling() {
		this.scroller = new InfiniteScroller({
			el: scrollContainer(this.el)
		})
		this.scroller.on('scroll', this.stream.next.bind(this.stream))
		this.stream.on('data', this.scroller.dataReady.bind(this.scroller))
	},

	onProject(e) {
		this.projectId = _.get(renderProjectDropdown.selectedProject(e), 'id', ALL_OPTION)
		this.renderOrgSelector()
		this.renderDashboards() // resets org selection
	},

	onOrg(e) {
		this.renderDashboards(e.target.value)
	},

	onDisplayLinks(e) {
		var dashboard = this._getSelectedDashboard(e)
		appDisplay.dialog($.get(`api/${this.section}/shared/` + dashboard.id), (links) => {
			return new SharedDashboardDialog({ links: links, section: dashboard.section || this.section })
		})
	},

	onDelete(e) {
		var dashboard = this._getSelectedDashboard(e)
		let section = this.section === 'dashboards' ? dashboard.section : this.section
		var domainLabel = i18n.get(metadata[section].singularCode)
		var description = i18n.get('common.embeddableResource.embeddableResource', domainLabel)
		var confirmation = new DeleteConfirmation({description})
		appDisplay.dialog(confirmation)
		confirmation.once('confirm', () => {
			var url = 'api/' + this.section + '/shared/' + dashboard.id
			$.delete(url, data => {
				$(e.target).closest('tr').remove()
				_.remove(this.dashboards, {id: dashboard.id})
				confirmation.trigger('done')
			})
		})

		// Show empty state if that was the last in the list
		confirmation.once('done', () => {
			if (_.isEmpty(this.dashboards)) {
				this.showEmptyState()
			}
		})
	},

	// JSONStream Data Handlers

	/**
	 * Invoked by JSonStreamer.on('data') from the XHR response, based on the name of the
	 * payload attribute(s), in this case 'organizations'
	 *
	 * @param {Array} organizations list of id/label objects
	 */
	setOrganizations(organizations) {
		this.organizations = organizations

		if (!_.includes(_.map(organizations, 'projectId'),this.projectId)) {
			// If the currently selected project has no shared dashboards then
			// this will become the default selection (it's first in the list)
			// so we must overwrite the projectId so the shared dashboards are visible
			this.projectId = ALL_OPTION
		}
		projects.isVisible() && this.renderProjectSelector()

		// (#9928) If only a single org was returned show that in the select
		// Otherwise, use the last org that was visited prior to coming to the admin section
		// But if no org was selected leave empty
		const defaultOrgId = _.size(organizations) === 1 ? organizations[0].organizationId : globals.orgId
		const selectedOrgId = this.renderOrgSelector(defaultOrgId)
		// If the previous global org is not in the list, the table will be empty
		// So show everything
		this.renderDashboards(selectedOrgId)
	},

	/**
	 * Invoked from JsonStreamer#initiate as soon as the stream is started
	 * @param {Chunker} stream
	 */
	setupStream: function(stream) {
		this.stream = stream
	},

	_listenForData: function () {
		this.stream.once('data', () => {
			this._logTimeDiff('First chunk of data received')
			this.table.show()
		})

		this.stream.on('data', data => {
			_.each(data, item => {
				this.hasData = true
				this.dashboards.push(item)
				this._renderItem(item)
			})
		})

		this.stream.once('data', () => {
			this._logTimeDiff('Finished listing shared dashboards')
			_.defer(() => this._logTimeDiff('Browser done rendering'))
		})

		// 'end' is emitted once from the chunker if no data received
		this.stream.on('end', () => {
			if (!this.hasData) {
				this.showEmptyState()
			}
		})
	},

	showEmptyState: function() {
		let message
		if (this.section === 'forms') {
			message = 'admin.sharedForms.none'
		} else {
			// #30037 use "dashboards or strategy maps" if strategy maps enabled
			message = config.displayStrategyMaps ?
			  'admin.sharedDashboards.strategyMaps.none' : 'admin.sharedDashboards.none'
		}

		let sectionIcon = metadata[this.section].sectionIcon
		appDisplay.display(new EmptyState({
			heading: this.heading(),
			body: emptyTemplate({sectionIcon, message})
		}))
	},

	//Rendering

	renderProjectSelector() {
		this.projectSelector.show()
		const projectIds = _.uniq(_.map(this.organizations, 'projectId'))
		const visibleProjects = _.filter(projects.asArray(), p => _.includes(projectIds, p.id))

		this.projectSelector = this.$('select.project-list')
		renderProjectDropdown(this.projectSelector, {
			projects: [this.ALL_PROJECTS].concat(visibleProjects),
			projectId: this.projectId
		})
	},

	/**
	 * Shows the org selector with orgs filtered based on the project
	 * @param {Number} [defaultOrgId] The org to select if present
	 *
	 * @return {Boolean} true if defaultOrgId was present in the list of visible organizations
	 */
	renderOrgSelector(defaultOrgId) {
		let organizations = this.organizations
		if (this.projectId != ALL_OPTION) {
			organizations = _.filter(this.organizations, {projectId: this.projectId})
		}
		let containsDefaultOrgId = false
		const options = [this.ALL_ORGS_OPTION].concat(_.map(organizations, org => {
			containsDefaultOrgId = containsDefaultOrgId || org.id == defaultOrgId
			return {
				label: org.label,
				value: org.id,
				selected: org.id == defaultOrgId
			}
		}))
		const selectOptions = {options, sort: []}
		selects.filtering(this.$('select.org-list'), selectOptions)
		this.orgSelector.show()

		return containsDefaultOrgId && defaultOrgId
	},

	/**
	 * @param {Number} [orgId] The selected orgId, if undefined show all
	 */
	renderDashboards(orgId) {
		this.orgId = orgId
		this.tableBody.empty()
		_.each(this.dashboards, item => this._renderItem(item))
		this.scroller.checkScroll()
	},

	_renderItem: function (item) {
		var {specificCalendarPeriodId: periodId, calendarId, organizationId, projectId} = item

		const allProjects = !this.projectId || this.projectId == ALL_OPTION
		const allOrgs = !this.orgId || this.orgId == ALL_OPTION
		const projectMatch = projectId == this.projectId
		const orgMatch = organizationId == this.orgId

		let include = (allProjects && allOrgs) ||
			(allProjects && orgMatch) ||
			(projectMatch && (orgMatch || allOrgs))

		if (include) {
			const {userId, userLabel, createdByUserId, createdByLabel} = item
			if (item.relativePeriodLabel) {
				item.periodLabel = `${item.relativePeriodLabel}, ${calendars.calendarsById[calendarId].label}`
			} else if (_.isNumber(periodId)) {
				item.periodLabel = calendars.periodsById[periodId].label
			}
			item.projectLabel = projects.get(projectId).get('label')
			item.sectionLabel = item.section ? metadata[item.section].singularCode : null
			item.section = item.section || this.section
			this.tableBody.append(rowTemplate(_.extend({
				isForms: this.section === 'forms',
				projectsEnabled: projects.isVisible(),
				strategyMapsEnabled: config.displayStrategyMaps,
				setupBy: createdByUserId === userId ? item.userLabel :
					i18n.get('common.user.createdByAs',
						createdByLabel, userLabel)
			},item)))
		}
	},

	// Util

	_getSelectedDashboard: function(e) {
		var data = $(e.target).closest('tr').data()
		return {
			id: data.resourceId,
			section: data.section
		}
	},

	_logTimeDiff: function (text) {
		console.log(text + ' after ' + moment().diff(this.options.start) + 'ms')
	},

	remove: function () {
		Backbone.View.prototype.remove.apply(this, arguments)
		_.invokeMap([this.covertButtonTooltips, this.loadingDots], 'remove')
	}

})

export default SharedDashboards

SharedDashboards.__filename__ = 'admin/shared-dashboards/admin-shared-dashboards.js'
